<template>
  <div>
    <button-options
      :access="access"
      :hideAdd="true"
      :hideDelete="false"
      :hideEdit="false"
      :hideDetail="false"
      :hideDuplicate="false"
      @onDeleteClicked="onDeleteClicked"
      @onEditClicked="onEditClicked"
      @onViewClicked="onViewClicked"
      @onDuplicateClicked="onDuplicateClicked"/>
  </div>
</template>

<script>
import ButtonOptions from '../directives/button-options';

export default {
  name: 'DeviceEdit',
  components: { ButtonOptions },
  props: ['access', 'device'],
  data() {
    return {
      isSubmit: false,
    };
  },
  computed: {
    data() {
      return { ...this.device };
    },
  },
  methods: {
    onDeleteClicked() {
      this.$emit('onDeleteClicked', this.data);
    },
    onEditClicked() {
      this.$emit('onEditClicked', this.data);
    },
    onDuplicateClicked() {
      this.$emit('onDuplicateClicked', this.data);
    },
    onViewClicked() {
      this.$emit('onViewClicked', this.data);
    },
  },
};
</script>

<style scoped>

</style>
